import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > form {
    width: 100%;

    flex: 1;

    margin-bottom: 2rem;
  }
`;
